import { all, takeEvery, put, call } from 'redux-saga/effects'
import history from '../../history'
import {
  getCategorias,
  getCategoriasChilds,
  getCategoriasFiltered,
  getCategoriaById,
  updateCategoria,
  insertCategoria,
  deleteCategoria,
  getCategoriaPersonalizados,
  getSubCategorias,
  deleteCategoriaList,
  updateCategoriaPersonalizado,
} from 'services/catalogo'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'

export function* GET_CATEGORIAS() {
  try {
    const categoriasData = yield call(getCategorias)
    if (categoriasData.ok) {
      yield put({
        type: actions.CATEGORIAS_LOAD_SUCCEEDED,
        payload: categoriasData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar categorias')
      put({
        type: actions.CATEGORIAS_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.CATEGORIAS_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_CATEGORIAS_CHILD() {
  try {
    const categoriasData = yield call(getCategoriasChilds)
    if (categoriasData.ok) {
      yield put({
        type: actions.CATEGORIAS_LOAD_SUCCEEDED,
        payload: categoriasData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar categorias')
      put({
        type: actions.CATEGORIAS_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.CATEGORIAS_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_CATEGORIAS_FILTERED(action) {
  try {
    const categoriasFilteredData = yield call(getCategoriasFiltered, action.payload)
    if (categoriasFilteredData.ok) {
      yield put({
        type: actions.CATEGORIAS_LOAD_SUCCEEDED,
        payload: categoriasFilteredData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar categorias')
      put({
        type: actions.CATEGORIAS_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.CATEGORIAS_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_SUBCATEGORIAS(action) {
  try {
    const subCategoriasData = yield call(getSubCategorias, action.payload)
    if (subCategoriasData.ok) {
      yield put({
        type: actions.SUBCATEGORIAS_LOAD_SUCCEEDED,
        payload: subCategoriasData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar subcategorias')
      put({
        type: actions.SUBCATEGORIAS_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.SUBCATEGORIAS_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_CATEGORIA_PERSONALIZADOS() {
  try {
    const categoriaPersonalizadosData = yield call(getCategoriaPersonalizados)
    if (categoriaPersonalizadosData.ok) {
      yield put({
        type: actions.CATEGORIA_PERSONALIZADOS_LOAD_SUCCEEDED,
        payload: categoriaPersonalizadosData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar categoria personalizados')
      put({
        type: actions.CATEGORIA_PERSONALIZADOS_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.CATEGORIA_PERSONALIZADOS_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_CATEGORIA_BY_ID(action) {
  try {
    const categoriaData = yield call(getCategoriaById, action.payload)
    if (categoriaData.ok) {
      yield put({
        type: actions.CATEGORIA_BYID_LOAD_SUCCEEDED,
        payload: categoriaData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar categoria')
      put({
        type: actions.CATEGORIA_BYID_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.CATEGORIA_BYID_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_CATEGORIA(action) {
  try {
    const categoriaObj = yield call(updateCategoria, action.payload)
    if (categoriaObj.ok) {
      putMessage(messageType.SUCCESS, 'Categoria modificada correctamente')
      yield put({
        type: actions.CATEGORIA_UPDATE_SUCCEEDED,
        payload: categoriaObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar categoria')
      yield put({
        type: actions.CATEGORIA_UPDATE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar categoria')
    yield all([
      put({
        type: actions.CATEGORIA_UPDATE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_CATEGORIA(action) {
  try {
    const categoriaObj = yield call(insertCategoria, action.payload)
    if (categoriaObj.ok) {
      putMessage(messageType.SUCCESS, 'Categoria creada correctamente')      
      yield put({
        type: actions.CATEGORIA_INSERT_SUCCEEDED,
        payload: categoriaObj.data,
      })      
      history.push(`/categorias/edit/${categoriaObj.data.id}`)
    } else {
      putMessage(messageType.ERROR, 'Error al crear categoria')
      yield put({
        type: actions.CATEGORIA_INSERT_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear categoria')
    yield all([
      put({
        type: actions.CATEGORIA_INSERT_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_CATEGORIA(action) {
  try {
    const categoriaResult = yield call(deleteCategoria, action.payload)
    if (categoriaResult.ok) {
      putMessage(messageType.SUCCESS, 'Categoria eliminada correctamente')
      yield put({
        type: actions.CATEGORIA_DELETE_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar categoria')
      yield put({
        type: actions.CATEGORIA_DELETE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar categoria')
    yield all([
      put({
        type: actions.CATEGORIA_INSERT_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_CATEGORIAS(action) {
  try {
    const categoriasResult = yield call(deleteCategoriaList, action.payload)
    if (categoriasResult.ok) {
      putMessage(messageType.SUCCESS, 'Categorias eliminadas correctamente')
      yield put({
        type: actions.CATEGORIAS_DELETE_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar categorias')
      yield put({
        type: actions.CATEGORIAS_DELETE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar categorias')
    yield all([
      put({
        type: actions.CATEGORIAS_INSERT_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_CATEGORIA_PERSONALIZADO(action) {
  try {
    const categoriaPersoObj = yield call(updateCategoriaPersonalizado, action.payload)
    if (categoriaPersoObj.ok) {
      putMessage(messageType.SUCCESS, 'Categoria personalizado modificada correctamente')
      yield put({
        type: actions.CATEGORIA_PERSONALIZADOS_UPDATE_SUCCEEDED,
        payload: categoriaPersoObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar categoria personalizado')
      yield put({
        type: actions.CATEGORIA_PERSONALIZADOS_UPDATE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar categoria personalizado')
    yield all([
      put({
        type: actions.CATEGORIA_PERSONALIZADOS_UPDATE_FILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.CATEGORIAS_LOAD_REQUESTED, GET_CATEGORIAS),
    takeEvery(actions.CATEGORIAS_LOAD_FILTERED_REQUESTED, GET_CATEGORIAS_FILTERED),
    takeEvery(actions.CATEGORIAS_CHILD_LOAD_REQUESTED, GET_CATEGORIAS_CHILD),
    takeEvery(actions.SUBCATEGORIAS_LOAD_REQUESTED, GET_SUBCATEGORIAS),
    takeEvery(actions.CATEGORIA_PERSONALIZADOS_LOAD_REQUESTED, GET_CATEGORIA_PERSONALIZADOS),
    takeEvery(actions.CATEGORIA_BYID_LOAD_REQUESTED, GET_CATEGORIA_BY_ID),
    takeEvery(actions.CATEGORIA_UPDATE_REQUESTED, UPDATE_CATEGORIA),
    takeEvery(actions.CATEGORIA_INSERT_REQUESTED, INSERT_CATEGORIA),
    takeEvery(actions.CATEGORIA_DELETE_REQUESTED, DELETE_CATEGORIA),
    takeEvery(actions.CATEGORIAS_DELETE_REQUESTED, DELETE_CATEGORIAS),
    takeEvery(actions.CATEGORIA_PERSONALIZADOS_UPDATE_REQUESTED, UPDATE_CATEGORIA_PERSONALIZADO),
  ])
}
